exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.reg-form-input[data-v-c27482c4] {\n  margin: 10px 0;\n}\n", "", {"version":3,"sources":["/home/ubuntu/BookingSystemV2/components/Login.vue"],"names":[],"mappings":";AACA;EACE,eAAe;CAChB","file":"Login.vue","sourcesContent":["\n.reg-form-input[data-v-c27482c4] {\n  margin: 10px 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/home/ubuntu/BookingSystemV2/assets","/static":"/home/ubuntu/BookingSystemV2/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c27482c4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Login.vue
// module id = ./node_modules/css-loader/index.js?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/home/ubuntu/BookingSystemV2/assets","/static":"/home/ubuntu/BookingSystemV2/static"}}!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-c27482c4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Login.vue
// module chunks = 7